// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"8f273362","294":"78dfdc0c","377":"9c9984b4","860":"ee2ba8b9"}[chunkId] + ".chunk.js";
};